module.exports = __webpack_public_path__ + "img/ljubimova.a1e765a7.jpg";